import React from 'react';

import type { TranslateProps } from '@travel/translation';
import TranslateFromLib from '@travel/traveler-core/components/Translate';

export function Translate({ data = {}, ...props }: TranslateProps) {
  return <TranslateFromLib data={data} {...props} />;
}

export { useTranslate } from '@travel/translation';
